/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useMemo } from "react";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { NodWereHouseRoute } from "../../nod-were-house.routes";
import { columns } from "./components/columns";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useDispatch } from "react-redux";
import {
  getInventoryStatusBannedItemsListingAction,
  getInventoryStatusListingActionNOD,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import { loader as loading } from "src/app-redux/warehouse/wareHouseSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { useFormik } from "formik";
import { Grid, MenuItem, Select, FormControl, InputLabel, Box } from "@material-ui/core";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";

const rows: any = [
  { typeOfCargo: "item1", totalWeight: 342 },
  { typeOfCargo: "item2", totalWeight: 839 },
  { typeOfCargo: "item3", totalWeight: 563 },
  { typeOfCargo: "item4", totalWeight: 9374 },
];

export function ListStatus() {
  const dispatch = useDispatch();
  const loader: any = useAppSelector(loading);

  const [moduleName, setmoduleName] = useState<any>(NodWereHouseRoute.title);
  const [pageHeading, setpageHeading] = useState<any>(
    NodWereHouseRoute.subRoutes ? NodWereHouseRoute.subRoutes[2].title : "Page Title"
  );
  const [pageSize, setPageSize] = React.useState(15);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const [isOpenDailog, setIsOpenDailog] = useState(false);
  const [selectedStatusType, setSelectedStatusType] = useState<any>(
    { id: 0, name: "Cargo" }
  );

  const formik = useFormik({
    initialValues: {
      bannedItems: false,
    },
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));
    },
  });
  const addSerialNumber = async (rows: any) => {
    const transformedData = await rows?.map((row: any, index: number) => ({
      ...row,
      id: index,
      sNo: index + 1,
    }));
    return transformedData;
  };

  const getInventoryStatus = async (isOtherItemRequest: boolean) => {
    const date = {
      daily: null,
      monthly: null,
      yearly: null,
      isOtherItemRequest: isOtherItemRequest,
    };
    const results: any = await dispatch(getInventoryStatusListingActionNOD(date));
    const rows = await results?.payload?.inventryStatusLists;
    const transformedRows: any = await addSerialNumber(rows);
    setGridRecord(transformedRows);
  };

  const StatusTypeLinst = [
    { id: 0, name: "Cargo" },
    { id: 1, name: "Seized" },
    { id: 2, name: "Others" },
  ];
  const getInventoryStatusBannedItems = async () => {
    const date = {
      daily: null,
      monthly: null,
      yearly: null,
    };
    const results: any = await dispatch(getInventoryStatusBannedItemsListingAction(date));
    const rows = await results?.payload?.inventryBannedItemLists;
    const transformedRows: any = await addSerialNumber(rows);
    setGridRecord(transformedRows);
  };
  
  useEffect(() => {
    getInventoryStatus(false);
  }, []);

  useEffect(() => {
    if (rows.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "totalWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const value = `${row.original.totalWeight ? row.original.totalWeight : "0"}`;
                const weightUnit = ` ${
                  row.original.weightUnit
                    ? row.original.weightUnit == "Cubic meter"
                      ? "m³"
                      : row.original.weightUnit
                    : "KG"
                }`;
                return `${value} ${weightUnit} `;
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, []);

  const toggleDialog = async () => {
    setIsOpenDailog(!isOpenDailog);
  };

  return (
    <>
      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            rows={gridRecord}
            columns={displayColumns}
            defaultPerPageRecord={pageSize}
            loader={loader}
            height={450}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            {/* <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(formik.values.bannedItems)}
                    onChange={formik.handleChange}
                    name="bannedItems"
                    color="primary"
                  />
                }
                label="Seized goods"
              />
            </Grid> */}
            <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Status Type"
                          placeholder="Select Status Type"
                          name="StatusType"
                          optionsType={StatusTypeLinst}
                          getOptionLabel={(option: any) => option.name || ""}
                          value={selectedStatusType}
                          onChange={(option: any) => {
                            if (option) {
                              setSelectedStatusType(option);
                              if(option.id == 0)
                                {
                                  getInventoryStatus(false)
                                }
                                else if(option.id == 1)
                                  {
                                    getInventoryStatusBannedItems();
                                  }
                                  else if(option.id ==2)
                                    {
                                      getInventoryStatus(true);
                                    }
                              
                            }
                          }}
                        />
                      </Box>
                    </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
    </>
  );
}
